import startCase from "lodash/startCase";
import i18n from "i18n";
import { CLUSTER_HEALTH_ALERT_TARGET } from "./target";
const fallbackReadableTarget = (target) => target.split(".").map(startCase).join(" / ");
const readableHealthAlertTarget = (target, paths) => {
  if (target === CLUSTER_HEALTH_ALERT_TARGET)
    return i18n.t("health.alert.cluster_health", { ns: "enterprise_license" });
  const path = paths[target];
  return path ? path.map((segment) => segment.title).join(" / ") : fallbackReadableTarget(target);
};
export default readableHealthAlertTarget;
